import React from "react";
import { X } from "lucide-react";

interface ModalLayoutProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

export const ModalLayout: React.FC<ModalLayoutProps> = ({
  isOpen,
  onClose,
  title,
  subtitle,
  icon,
  children,
  footer,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center p-2 sm:p-4 z-60 backdrop-blur-md">
      <div className="bg-(--card-bg) rounded-2xl shadow-2xl w-full max-w-5xl max-h-[95vh] sm:max-h-[90vh] overflow-hidden border border-(--border-color) flex flex-col">
        <div className="p-4 sm:p-6 border-b border-(--border-color) flex items-center justify-between">
          <div className="flex items-center gap-3">
            {icon && (
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl flex items-center justify-center">
                {icon}
              </div>
            )}
            <div>
              <h2 className="text-xl sm:text-2xl font-bold text-(--text-primary)">
                {title}
              </h2>
              {subtitle && (
                <p className="text-[12px] sm:text-sm text-(--text-tertiary)">
                  {subtitle}
                </p>
              )}
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-(--bg-accent) rounded-lg transition"
          >
            <X className="w-5 h-5 text-(--text-tertiary)" />
          </button>
        </div>

        <div className="overflow-y-auto flex-1 p-0">{children}</div>

        {footer && (
          <div className="p-4 border-t border-(--border-color) flex justify-between items-center shrink-0">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};
